import { Form } from "antd";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  PASSWORD_REGEX,
  PASSWORD_REQUIREMENTS_MESSAGE,
} from "../../helpers/constants";
import { changePassword } from "../../slices/Employee/editEmployeeProfile.slice";
import { showSuccess } from "../../helpers/Notifications/Notification";
import FormItem from "../UI/FormItem";

const ChangePasswordForm = ({ onCancel }) => {
  const { editProfileError } = useSelector(
    (state) => state.editEmployeeProfile
  );
  const dispatch = useDispatch();

  const onSubmitSuccess = (values) => {
    const data = {
      old_password: values.old_password,
      new_password: values.new_password,
      confirm_password: values.confirm_password,
    };
    dispatch(
      changePassword(data, () => {
        showSuccess("Password Changed Successfully");
        onCancel();
      })
    );
  };

  return (
    <div>
      <Form
        layout="vertical"
        onFinish={onSubmitSuccess}
        autoComplete="off"
        style={{ paddingTop: 20 }}
        validateTrigger="onBlur"
      >
        <FormItem
          name="old_password"
          rules={[
            {
              required: true,
              message: "Please fill the old password to proceed!",
            },
          ]}
          placeholderText={"Old Password"}
          inputType="password"
          formErrors={editProfileError}
        />
        <FormItem
          name="new_password"
          rules={[
            {
              required: true,
              message: "Please fill the new password to proceed!",
            },
            {
              pattern: PASSWORD_REGEX,
              message: PASSWORD_REQUIREMENTS_MESSAGE,
            },
          ]}
          placeholderText={"New Password"}
          inputType="password"
          hasFeedback
          autocomplete="off"
          formErrors={editProfileError}
        />
        <FormItem
          name="confirm_password"
          dependencies={["new_password"]}
          rules={[
            {
              required: true,
              message: "Please confirm the new password to proceed!",
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("new_password") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error("The two passwords that you entered do not match!")
                );
              },
            }),
          ]}
          placeholderText={"Confirm New Password"}
          inputType="password"
          autocomplete="off"
          formErrors={editProfileError}
        />
        <div className="actions-container">
          <button className="login-btn cancel" type="button">
            <span className="login-btn-text" onClick={() => onCancel()}>
              CANCEL
            </span>
          </button>

          <button className="login-btn" type="submit">
            <span className="login-btn-text">UPDATE</span>
          </button>
        </div>
      </Form>
    </div>
  );
};

export default ChangePasswordForm;
